import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { callAPI } from "../../../App/Helpers/callApi";
import {
  addFeaturedGroup,
  getFeaturedGroups,
} from "../../FeaturedGroupsPage/FeaturedGroupsService";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";
import { addEventType } from "../EventTypesService";
import { getEventTypes } from "../EventTypesService";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  copy: {
    color: theme.palette.primary.copy,
  },
}));
export default function AddEventTypeModal({
  openModal,
  client,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
}) {
  const classes = useStyles();
  const [name, setName] = useState("");
  const [processing, setProcessing] = useState(false);

  function addType() {
    let json = {
      ClientId: client.id,
      Name: name,
    };

    callAPI(
      addEventType(json),
      "Type Added",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEventTypes(client.id).then((response) => {
        setTableData(response);
        openModal(false);
      });
    });
  }

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Add Event Type
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Add Name"
                  label="Add Name"
                  variant="standard"
                  fullWidth
                  required
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => addType()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
